<template>
    <div class="stretch-layout">
        <template v-if="resultListGroupsData.length">
            <card v-for="resultListGroupData in resultListGroupsData" :key="resultListGroupData.id" xs-tile sm-tile :id="resultListGroupData.id" class="stretch-layout">
                <card-title>{{ resultListGroupsData.length === 1 ? $t('label.results') : resultListGroupData.name }}</card-title>
                <card-subtitle spaced-content>{{ $t('text.select_result_list_group_for_results') }}</card-subtitle>

                <settings-list v-if="resultListGroupData.resultListGroups.length">
                    <settings-list-item v-for="resultListGroup in resultListGroupData.resultListGroups"
                                        :key="resultListGroup.id"
                                        :title="resultListGroup.name"
                                        :description="resultListGroup.description"
                                        :to="$app('events-event-results-group', {params: {event: eventStore.event._key, group: resultListGroup._key}, state: {group_ts: resultListGroup.cache_buster}})"/>
                </settings-list>

                <card-text v-if="resultListGroupData.items?.length" class="mt-16">
                    <card v-for="resultListGroupDataItem in resultListGroupData.items" :key="resultListGroupDataItem.id" outlined :style="{borderLeft: `2px solid ${eventStore.colorStyle} !important`}">
                        <card-title small spaced-content>{{ resultListGroupDataItem.name }}</card-title>

                        <settings-list>
                            <settings-list-item v-for="resultListGroup in resultListGroupDataItem.resultListGroups"
                                                :key="resultListGroup.id"
                                                :title="resultListGroup.name"
                                                :description="resultListGroup.description"
                                                :to="$app('events-event-results-group', {params: {event: eventStore.event._key, group: resultListGroup._key}, state: {group_ts: resultListGroup.cache_buster}})"/>
                        </settings-list>
                    </card>
                </card-text>
            </card>
        </template>
        <lazy-missing-info v-else :text="$t('missing.results.index')" xs-tile sm-tile card class="flex-grow-1"/>
    </div>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../../store/event";
const eventStore = useEventStore();
const {t} = useI18n();
const {$web} = useNuxtApp();

// Make sure the page is activated
const page = eventStore.getPage(EventPageType.Results);
if (!page) {
	await navigateTo(eventStore.hasActivePage(EventPageType.Participations) ? $web('events.participations.index', eventStore.event._key) : $web('events.show', eventStore.event._key));
}

const {data: resultListGroupsData} = await useApiFetch(`/v1/view/events/${eventStore.event.id}/result-list-groups`, {
	guest: true
});

useMeta({
	title: eventStore.buildPageTitle(t('view.events.participations.results.title', {event: eventStore.event.display_name})),
	description: t('view.events.participations.results.description', {event: eventStore.event.display_name}),
});

</script>

